export default __webpack_public_path__ + "94d9d22bbe566d42524a86742f74fed5.js";